import moment from 'moment';
import React, { useEffect, useState } from 'react';

function MyStopwatch({ horainicio, startClock, tempojogo, parteativa, tempoparte, datainicioparte, numpartes  }) {

  const [time, setTime] = useState(0);
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {

    const calculateOffset = () => {
    const today = new Date();
    
    // If parteativa is 'intervalo', timer is stopped and should show tempoparte value
    if (parteativa === 'intervalo') {
        // Return tempoparte converted to milliseconds (tempoparte is in minutes)
        return tempoparte * 60 * 1000;
    }
    
    let startDate;
    
    if (parteativa === 'primeira') {
        // For first part, use datainicioparte as start time
        startDate = new Date(datainicioparte);
    } else if (parteativa === 'segunda') {
        // For second part, start time is datainicioparte + tempoparte (minutes)
        startDate = new Date(datainicioparte);
        startDate.setMinutes(startDate.getMinutes() - tempoparte);
    } else {
        // Fallback to original horainicio if parteativa is not recognized
        startDate = new Date(horainicio);
    }
    
    // Calculate time difference in seconds, then convert to milliseconds
    let offsetSeconds = parseInt(Math.abs(today.getTime() - startDate.getTime()) / 1000);
    return offsetSeconds * 1000;
}

    let isActive = true;
    let interval = null;
    if (isActive) {
      interval = setInterval(() => {
        setTime(calculateOffset);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [tempojogo, startClock, horainicio, parteativa, tempoparte, datainicioparte, numpartes]);

  // Effect to handle flashing when time exceeds tempoparte
  useEffect(() => {
    const tempo = parteativa === 'primeira' ? tempoparte : parteativa === 'segunda' ? tempoparte * numpartes : tempoparte;
    const shouldFlash = Math.floor(time / 60000) >= tempo && parteativa !== 'intervalo';
    
    if (shouldFlash) {
      const flashInterval = setInterval(() => {
        setIsFlashing(prev => !prev);
      }, 500); // Flash every 500ms
      
      return () => clearInterval(flashInterval);
    } else {
      setIsFlashing(false);
    }
  }, [time, tempoparte,parteativa]);

  return (
    <>
      {time > 0 ?
        (<div style={{ textAlign: 'center' }}>
          <div style={{ 
            fontSize: '25px',
            color: isFlashing ? 'red' : 'inherit',
            fontWeight: isFlashing ? 'bold' : 'normal',
            opacity: isFlashing ? 0.5 : 1,
            transition: 'opacity 0.1s ease-in-out'
          }}>
            { 
              <><span>{ 
                ("0" + Math.floor((time / 60000) % 60)).slice(-2)}</span>:<span>{("0" + Math.floor((time / 1000) % 60)).slice(-2)}</span></>}
          </div>
        </div>) : null
      }
    </>
  );
}

export default MyStopwatch